PluginButtonView = require 'views/plugin/plugin-button-view'
t = require('views/internal/teacup-with-helpers')()
track = require 'debug/track'
trackUe = require 'debug/trackUe'

template = t.renderable ({ icon, text }) ->
  iconColor = if @model.get('prefs').backgroundBrightness == 'light' then '000' else 'f6f6f6'
  if icon
    t.span '.board-header-btn-icon.icon-sm.plugin-icon',
      style: t.stylify
        'background-image': t.urlify "#{ icon }?color=#{ iconColor }"
  t.span '.board-header-btn-text.u-text-underline', ->
    t.text text
  return

module.exports = class PluginHeaderButtonView extends PluginButtonView
  className: 'board-header-btn'
  template: template

  trackClick: (pluginButton) ->
    track("Board Header", "Board Plugin Button", pluginButton.text)
    trackUe('board view', 'opens', 'Power-Up', '', '', 'board-button', pluginButton.idPlugin)



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-header-button-view.coffee